export const appConfig = {
    tenant: 'luvseats',
};